import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent,
} from '@mui/material';

const styles = {
  dialogPaper: {
    minHeight: '95vh',
    maxHeight: '95vh',
  },
};

function Modal({
  onClose, isOpen, children, onSave, onCancel, fullWidth,
}) {
  return (
    <Dialog
      PaperProps={{ style: styles.dialogPaper }}
      open={isOpen}
      fullWidth={fullWidth}
      maxWidth="xl"
      aria-labelledby="form-dialog-title"
      onClose={onClose || onCancel}
    >
      <DialogContent>
        {children}
      </DialogContent>
      {onSave && onCancel && (
        <DialogActions>
          <Button
            onClick={onCancel}
            color="primary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            color="primary"
            variant="contained"
          >
            Save and Close
          </Button>
        </DialogActions>
      )}
      {!onSave && !onCancel && (
        <DialogActions>
          <Button
            onClick={onClose}
            color="primary"
            variant="contained"
          >
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default Modal;
